export const BASE_URL = "https://jsonplaceholder.typicode.com";
export const LOGIN = "/tsp-auth/users/signin";
export const SSO_LOGIN = "/tsp-auth/v1/api/custom-sso/login";
export const SIGNUP = "/tsp-auth/users/create";
export const PROFILE = "/tsp-auth/users";
export const VERIFY_TOKEN = "/tsp-auth/v1/api/custom-sso/verify";
export const UPDATE_PROFILE = "/tsp-auth/users";
export const CHANGE_PASSWORD = "/tsp-auth/users/change-password";
export const FORGOT_PASSWORD = "/tsp-auth/users/forgot";
export const HERO_BANNER = "/tsp/user/v1/api/client-banner/client/";
export const CLIENT_CONFIG = "/tsp/user/v1/api/client-details";
export const ALL_CATEGORY_BY_CLIENT_ID = "/tsp/bill-details/v1/api/group/all";
export const ALL_GROUPS_BY_CATEGORY = "/tsp/bill-details/v1/api/biller/search";
export const BILLER_DETAILS_BY_ID = "/tsp/bill-details/v1/api/biller/";
export const ADD_BILL = "/tsp/bill-details/v1/api/bill/";
export const MY_BILLS = "/tsp/bill-details/v1/api/bill/";
export const BILL_DETAILS_BY_ID = "/tsp/bill-details/v1/api/bill";
export const ALL_CATEGORY_LISTS_CLIENT_ID = "/tsp/bill-details/v1/api/display";
export const PREPARE_PAYMENT =
  "/tsp/bill-details/v1/api/payment/prepare_payment";
export const VERIFY_PAYMENT = "/tsp/bill-details/v1/api/payment/verify_payment";
export const PAYU_URL = "https://test.payu.in/_payment";
export const ALL_TRANSACTIONS = "/tsp/bill-details/v1/api/transaction/search";
export const DOWNLOAD_TRANSACTIONS =
  "/tsp/bill-details/v1/api/transaction/download";
export const DOWNLOAD_INVOICE_TRANSACTIONS =
  "/tsp/bill-details/v1/api/transaction";
export const SPEND_ANALYSIS_DETAIL =
  "/tsp/bill-details/v1/api/transaction-summary/category/all";
export const DELETE_BILL_BY_ID = "/tsp/bill-details/v1/api/bill";
export const EDIT_BILL_BY_ID = "/tsp/bill-details/v1/api/bill/";
export const VERIFY_TXN = "/tsp/bill-details/v1/api/payment/verify_payment";
export const GET_ALL_FAQ = "/tsp/user/v1/api/faq/";
export const GET_FAQ_BY_GROUP_NAME = "/tsp/user/v1/api/faq/group";
export const TRANSACTION_DETAILS_BY_ID =
  "/tsp/bill-details/v1/api/payment/transaction";
export const BILLS_BY_CATEGORY_ID =
  "/tsp/bill-details/v1/api/transaction/search";
export const UPDATE_BILLER_NICK_NAME = "/tsp/bill-details/v1/api/bill/";
export const FAQ_GROUPS = "/tsp/user/v1/api/faq/group/";
export const CREATE_SI = "/tsp/bill-details/v1/api/si/";
export const SI_LIST = "/tsp/bill-details/v1/api/si/all";
export const GET_REMINDERS_EVENTS =
  "/tsp/bill-details/v1/api/reminders/events/subtypes";
export const SAVE_REMINDER = "/tsp/bill-details/v1/api/reminders/";
export const GET_ALL_REMINDERS = "/tsp/bill-details/v1/api/reminders/";
export const GET_REMINDERS_BY_ID = "/tsp/bill-details/v1/api/reminders";
export const GET_REMINDERS_BY_BILL_ID =
  "/tsp/bill-details/v1/api/reminders/userBillId/";
export const UPDATE_REMINDER = "/tsp/bill-details/v1/api/reminders/";
export const DELETE_REMINDER = "/tsp/bill-details/v1/api/reminders";
export const REMINDER_BASE_URL = "/tsp/bill-details/v1/api/reminders/";
export const GET_OPERATOR_CIRCLE_INFO =
  "/tsp/bill-details/v1/api/operator/operator-circle-info";
export const GET_OPERATOR_LIST = "/tsp/bill-details/v1/api/operator/";
export const GET_CIRCLE_BY_OPERATOR =
  "/tsp/bill-details/v1/api/mobile-prepaid/plans/circles";
export const RECHARGE_PLANS_BASE =
  "/tsp/bill-details/v1/api/mobile-prepaid/plans";
export const GET_RECHARGE_PLANS =
  "/tsp/bill-details/v1/api/mobile-prepaid/plans";
export const GET_RECHARGE_DETAILS_BY_ID =
  "/tsp/bill-details/v1/api/mobile-prepaid/plans";
export const GET_ALL_COMPLAINT =
  "/tsp/bill-details/v1/api/complaints/check-complaint/all";
export const GET_COMPLAINT_TYPES =
  "/tsp/bill-details/v1/api/complaints/messages";
export const RAISE_COMPLAINT = "/tsp/bill-details/v1/api/complaints/";
export const GET_COMPLAINT_DETAILS =
  "/tsp/bill-details/v1/api/complaints/transaction";
export const CREATE_MOBILE_PREPAID_BILL =
  "/tsp/bill-details/v1/api/bill/mobile-prepaid";
export const RECENT_RECHARGE =
  "/tsp/bill-details/v1/api/transaction/mobile-prepaid/history";
export const GET_PRIVACY_POLICY = "/tsp/user/v1/api/policy/";
export const GET_ABOUT_US = "/tsp/user/v1/api/aboutus/";
export const GET_NOTIFICATIONS =
  "tsp/notification/v1/notification-tracker/customer";

export const GET_TXN_DETAIL = "/tsp/bill-details/v1/meta/v1/nbc/txnDetails";
export const RAISE_COMPLAINT_CMS = "/tsp/bill-details/v1/meta/v2/nbc/raiseCms";

export const POST_IMAGE_URL =
  process.env.REACT_APP_API_SERVER + "/tsp/user/v1/api/document/upload/";

export const DOWNLOAD_IMAGE =
  process.env.REACT_APP_API_SERVER + "/tsp/user/v1/api/document/download";

export const PAYMENT_SUCCESS_URL =
  process.env.REACT_APP_API_SERVER + "/tsp/bill-details/v1/api/payment/success";

export const PAYMENT_FAILURE_URL =
  process.env.REACT_APP_API_SERVER + "/tsp/bill-details/v1/api/payment/failure";

export const PAYMENT_CANCEL_URL =
  process.env.REACT_APP_API_SERVER + "/tsp/bill-details/v1/api/payment/cancel";

export const NOTIFICATION_SUMMARY =
  process.env.REACT_APP_API_SERVER + "/tsp/notification/v1/notification-tracker/customer/summary";

export const NOTIFICATION_READ_MESSAGE =
  process.env.REACT_APP_API_SERVER + '/tsp/notification/v1/notification-tracker/read-message';

export const ADD_SHORT_NAME =
  process.env.REACT_APP_API_SERVER + '/tsp/bill-details/v1/api/bill/';

export const GET_COMPLAINT_DETAILS_BY_ID =
  process.env.REACT_APP_API_SERVER + '/tsp/bill-details/v1/api/complaints/complaint/';
// Add url
